import applications from '@/api/applications'

export default {
    namespaced: true,
    state: {
        items: [],
        selectedItem: null,
        editedId: -1,
        editedItem: {
            name: '',
            description: '',
            prices: [],
            trial: false,
            expire_days: 0,
            maximum_utilization: 0
        },
        defaultItem: {
            name: '',
            description: '',
            prices: [],
            trial: false,
            expire_days: 0,
            maximum_utilization: 0
        }
    },
    getters: {},
    actions: {
        fetchAll ({ commit }) {
            return new Promise((resolve, reject) => {
                applications.index().then(response => {
                    commit('setItems', response.data)
                    resolve(response.data)
                }).catch(error => reject(error));
            })
        },
    },
    mutations: {
        setItems (state, items) {
            state.items = items
        },
    }
}